<script>
import { MESSAGE_TYPE } from 'widget/helpers/constants';
import { MESSAGE_STATUS } from 'dashboard/components-next/message/constants';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';
import { escapeHtml } from 'shared/helpers/HTMLSanitizer';
import { replaceFlagEmojisWithIcons } from 'shared/helpers/flagEmoji';

export default {
  name: 'MessagePreview',
  props: {
    message: {
      type: Object,
      required: true,
    },
    showMessageType: {
      type: Boolean,
      default: true,
    },
    defaultEmptyMessage: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { getPlainText } = useMessageFormatter();
    return {
      getPlainText,
    };
  },
  computed: {
    messageByAgent() {
      const { message_type: messageType } = this.message;
      return messageType === MESSAGE_TYPE.OUTGOING;
    },
    isMessageAnActivity() {
      const { message_type: messageType } = this.message;
      return messageType === MESSAGE_TYPE.ACTIVITY;
    },
    isMessagePrivate() {
      const { private: isPrivate } = this.message;
      return isPrivate;
    },
    isMessageRead() {
      const { status } = this.message;
      return this.messageByAgent && status === MESSAGE_STATUS.READ;
    },
    parsedLastMessage() {
      const { content_attributes: contentAttributes } = this.message;
      const { email: { subject } = {} } = contentAttributes || {};
      return this.getPlainText(subject || this.message.content);
    },
    parsedLastMessageHtml() {
      return replaceFlagEmojisWithIcons(escapeHtml(this.parsedLastMessage));
    },
    lastMessageFileType() {
      const [{ file_type: fileType } = {}] = this.message.attachments;
      return fileType;
    },
    attachmentIcon() {
      const iconMap = {
        image: 'i-lucide-image',
        audio: 'i-lucide-mic',
        video: 'i-lucide-video',
        file: 'i-lucide-file-text',
        location: 'i-lucide-map-pin',
      };
      return iconMap[this.lastMessageFileType] || 'i-lucide-file';
    },
    attachmentMessageContent() {
      return `CHAT_LIST.ATTACHMENTS.${this.lastMessageFileType}.CONTENT`;
    },
    isMessageSticker() {
      return this.message && this.message.content_type === 'sticker';
    },
    isNullContent() {
      return this.message.content === 'null' || this.message.content === null;
    },
  },
};
</script>

<template>
  <div class="overflow-hidden text-ellipsis whitespace-nowrap">
    <template v-if="showMessageType">
      <span
        v-if="isMessagePrivate"
        class="i-lucide-sticky-note -mt-0.5 align-middle text-slate-600 dark:text-slate-300 inline-block mr-1 w-4 h-4"
      />
      <span
        v-else-if="messageByAgent"
        class="i-lucide-check-check -mt-0.5 align-middle inline-block mr-1 w-4 h-4"
        :class="isMessageRead ? 'text-woot-600' : 'text-slate-600 dark:text-slate-300'"
      />
      <span
        v-else-if="isMessageAnActivity"
        class="i-lucide-info -mt-0.5 align-middle text-slate-600 dark:text-slate-300 inline-block mr-1 w-4 h-4"
      />
    </template>
    <span v-if="message.attachments && message.content && !isNullContent && !isMessageSticker">
      <span
        v-if="attachmentIcon && showMessageType"
        class="-mt-0.5 align-middle inline-block text-slate-600 dark:text-slate-300 mr-1 w-4 h-4"
        :class="attachmentIcon"
      />
      <span v-dompurify-html="parsedLastMessageHtml"></span>
    </span>
    <span v-else-if="message.attachments">
      <span
        v-if="attachmentIcon && showMessageType"
        class="-mt-0.5 align-middle inline-block text-slate-600 dark:text-slate-300 mr-1 w-4 h-4"
        :class="attachmentIcon"
      />
      {{ $t(`${attachmentMessageContent}`) }}
    </span>
    <span v-else-if="isNullContent">
      <span
        class="i-lucide-image -mt-0.5 align-middle inline-block text-slate-600 dark:text-slate-300 mr-1 w-4 h-4"
      />
      Mídia
    </span>
    <span v-else-if="message.content && isMessageSticker">
      <span
        class="i-lucide-image -mt-0.5 align-middle inline-block text-slate-600 dark:text-slate-300 mr-1 w-4 h-4"
      />
      {{ $t('CHAT_LIST.ATTACHMENTS.image.CONTENT') }}
    </span>
    <span v-else-if="message.content">
      <span v-dompurify-html="parsedLastMessageHtml"></span>
    </span>
    <span v-else>
      {{ defaultEmptyMessage || $t('CHAT_LIST.NO_CONTENT') }}
    </span>
  </div>
</template>
